<template>
  <div>
    <div>
      <mdb-card class="card-image image" >
        <div class="text-white text-center rgba-stylish-strong py-5 px-4">
          <div class="py-5">
            <h5 class="h5 orange-text"><i class="fas fa-laptop"></i>ICT consultancy</h5>
            <h2 class="card-title h1 my-4 py-2">Hypertech IT consultants *</h2>
            <p class="mb-4 pb-2 px-md-5 mx-md-5">Hypertech  IT Consultants limited is an IT consulting and solution provider with experience spanning over 13 years.
            Over time, we have added various services to become an all round I.T. consulting and services provision firm.
            We have developed solutions for both big and small organizations. Our guiding philosophy has always been to enhance our clients' business processes and help their organizations grow" because we believe that when our clients grow, we grow.</p>
            <mdb-btn class="pulse-button" tag="a" gradient="peach" icon="clone" @click="$router.push('/portfolio')" >View Projects</mdb-btn>
          </div>
        </div>
    </mdb-card>
    </div>
    <div>
    </div>
  </div>

</template>

<script>
import mdbCard from 'mdbvue/lib/components/mdbCard'
import mdbBtn from 'mdbvue/lib/components/mdbBtn'

export default {
  components: {
    mdbCard,
    mdbBtn
  }
}
</script>

<style scoped>
  .customNav {
    background-color: white;
    top: 0;
    left: 0;
    right: 0;
    height: 80px;
}
.white {
  background-color: #bdc3c7;
}
.image {
  background: url("../assets/background1.jpeg");
}

.pulse-button {
  -webkit-animation: pulse 3.5s infinite;
  animation: pulse 3.5s infinite;
}
.pulse-button:hover {
  -webkit-animation: none;
  animation: none;
}
</style>
